/* eslint-disable import/prefer-default-export */
import * as yup from "yup";
import { PhoneEmailStatus } from "__generated__/gql/graphql";

export const statuses = [
  PhoneEmailStatus.UNVERIFIED,
  PhoneEmailStatus.VALID,
  PhoneEmailStatus.INVALID,
];

export const statusLabels: Record<PhoneEmailStatus, string> = {
  [PhoneEmailStatus.UNVERIFIED]: "Unverified",
  [PhoneEmailStatus.VALID]: "Valid",
  [PhoneEmailStatus.INVALID]: "Invalid",
};

export const status = yup
  .mixed<PhoneEmailStatus>()
  .oneOf(statuses)
  .required()
  .label("Status");
